import { useEffect, useState } from 'react';
import IMedia from 'shared/interfaces/IMedia';
import { IProfileMedia } from 'shared/interfaces/IProfile';
import { IUpload } from 'shared/interfaces/IUpload';
export type MediumProps = {
  id: string;
  file_type: 'audio' | 'video' | 'image' | 'document';
  file_name: string;
  file_size: number;
  file_width: number | null;
  file_height: number | null;
  visible: boolean;
  tag_list: string[];
  attachment_url?: string | null;
  modified_attachment_url?: string;
  cropped_attachment_url?: string;
  sort?: number;
  modified_attachment?: string | null;
  attachment?: string | null;
  cropped_attachment?: string | null;
};

type SliceProps = {
  length: number;
};

export const useMediaShareableProfileFormat = (
  mediaData: IProfileMedia[] | IMedia[] | IUpload[],
  slice?: SliceProps,
) => {
  const [mappedData, setMappedData] = useState<MediumProps[]>([]);
  useEffect(() => {
    if (mediaData && mediaData?.length) {
      if (slice) {
        const newSliceMappedImages: any = mediaData?.slice(0, slice?.length)?.map((data) => {
          return { ...data?.attributes };
        });
        setMappedData(newSliceMappedImages);
      } else {
        const newMappedImages: any = mediaData?.map((data) => {
          return { ...data?.attributes };
        });
        setMappedData(newMappedImages);
      }
    }
  }, [mediaData]);

  return { mappedData };
};
